@if (loading) {
  <div class="mapa-cargando" role="status">
    <mat-progress-spinner
      mode="indeterminate"
      color="primary"
      [diameter]="20"
    ></mat-progress-spinner>
    <span>Cargando alertas…</span>
  </div>
}

<div class="mapa-flotante">
  <app-flotante-alertas-seguridad
    [tiposActivos]="tiposActivos"
    [filtroTemporal]="filtroTemporal"
    [rangoPersonalizado]="rangoPersonalizado"
    [soloActivas]="soloActivas"
    [totalAlertas]="alertas.length"
    [totalEventos]="eventos.length"
    [totalSirenas]="sirenas.length"
    [dibujandoPoligono]="dibujandoPoligono"
    [buscandoPoligono]="buscandoPoligono"
    [exportandoPoligono]="exportandoPoligono"
    [resumenPoligono]="resumenPoligono"
    (tiposActivosChange)="onTiposActivosChange($event)"
    (filtroTemporalChange)="onFiltroTemporalChange($event)"
    (rangoPersonalizadoChange)="onRangoPersonalizadoChange($event)"
    (soloActivasChange)="onSoloActivasChange($event)"
    (iniciarPoligonoEvt)="iniciarPoligono()"
    (cancelarPoligonoEvt)="cancelarPoligono()"
    (limpiarPoligonoEvt)="limpiarPoligono()"
    (exportarPoligonoEvt)="exportarPoligono()"
  ></app-flotante-alertas-seguridad>
</div>

<app-mapa-facil-v2
  [center]="[-58.443832, -34.587386]"
  [zoom]="12"
  [style]="tipoMapaBase"
  [mapId]="'MapaAlertasSeguridadComponent'"
  [mapasPersonalizados]="mapasPersonalizados"
  [allowedEntityTypes]="allowedTypes"
  (mapReady)="onMapReady($event)"
></app-mapa-facil-v2>
